import moment from "moment";

const getCustomizedTimestamp = (oldDate) => {
  var dt = new Date(oldDate);
  return dt.toISOString();
};

const convertToMonthDayYear = (date) => {
  return moment(date).format("MM/DD/YYYY");
};

const convertToDayMonthYear = (date) => {
  if (!date) {
    return "";
  } else {
    return moment(date).format("DD/MM/YYYY");
  }
};

const convertToDayMonthYearHourMinSec = (date) => {
  if (!date) {
    return "";
  } else {
    return moment(date).format("DD/MM/YYYY hh:mm a");
  }
};

const validateMonthDateYearFormat = (date) => {
  if (
    moment(date, "MM/DD/YYYY", true).isValid() ||
    moment(date, "M/DD/YYYY", true).isValid() ||
    moment(date, "MM/D/YYYY", true).isValid() ||
    moment(date, "MM/DD/YY", true).isValid() ||
    moment(date, "M/D/YYYY", true).isValid() ||
    moment(date, "MM/D/YY", true).isValid() ||
    moment(date, "M/DD/YY", true).isValid() ||
    moment(date, "M/D/YY", true).isValid()
  ) {
    return true;
  } else {
    return false;
  }
};

const validateMonthDay = (date) => {
  if (
    moment(date, "MM/DD", true).isValid() ||
    moment(date, "M/DD", true).isValid() ||
    moment(date, "MM/D", true).isValid() ||
    moment(date, "M/D", true).isValid()
  ) {
    return true;
  } else {
    return false;
  }
};

const validateYear = (date) => {
  if (moment(date, "YYYY", true).isValid()) {
    return true;
  } else {
    return false;
  }
};

const getNowDate = () => {
  return Date.now();
};

const convertMonthDayYearToYearMonthDay = (date) => {
  if (date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  } else {
    return "";
  }
};

const getNowDateYearMonthDay = () => {
  return moment().format("YYYY-MM-DD");
};

const getCurrentTimeStamp = (date) => {
  if (date) {
    var gmtDateTime = moment.utc(date);
    return gmtDateTime.local().format("DD-MM-YYYY @ h:mm A");
  } else {
    return "";
  }
};

const getMonthDayYear = (date) => {
  if (date) {
    return moment(date).format("MM-DD-YYYY");
  } else {
    return "";
  }
};

const getMonthDateYearForFax = () => {
  var date = moment().format("YYYY-MM-DD");

  return moment(date).format("MMM DD, YYYY");
};

const getDate7DaysBefore = () => {
  return moment()
    .subtract(7, "d")
    .format("YYYY-MM-DD");
};

const localeToUTC = (localeDateTimeString) => {
  if (localeDateTimeString === null || localeDateTimeString === "") return "";
  const ProcessedString = localeDateTimeString.split("Z")[0];
  const utcDateTimeString =
    moment(ProcessedString)
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss") + "Z";
  return utcDateTimeString;
};

const UTCToLocale = (utcDateTimeString) => {
  if (utcDateTimeString === null || utcDateTimeString === "") return "";
  const localeDateTimeString =
    moment(utcDateTimeString).format("YYYY-MM-DDTHH:mm:ss") + "Z";
  console.log(localeDateTimeString);
  return localeDateTimeString;
};

const formattedDate = (inputDate) => {
  console.log(inputDate);
  const processedDate = new Date(inputDate).toLocaleString().split(":");
  console.log(processedDate);
  let newDateTimeString = processedDate[0] + ":" + processedDate[1];
  newDateTimeString += " ";
  newDateTimeString += processedDate[2].split(" ")[1];
  return newDateTimeString;
};

export {
  getCustomizedTimestamp,
  validateMonthDateYearFormat,
  validateMonthDay,
  validateYear,
  convertToMonthDayYear,
  getNowDate,
  convertToDayMonthYear,
  convertToDayMonthYearHourMinSec,
  convertMonthDayYearToYearMonthDay,
  getNowDateYearMonthDay,
  getCurrentTimeStamp,
  getMonthDayYear,
  getMonthDateYearForFax,
  getDate7DaysBefore,
  localeToUTC,
  UTCToLocale,
  formattedDate,
};
